<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('user.disposition.title')" prop="title">
                <a-input v-model="queryParam.title" :placeholder="$t('system.inputPlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('user.disposition.isOpen')" prop="isOpen">
                  <a-input v-model="queryParam.isOpen" :placeholder="$t('user.disposition.inputIsOpen')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('user.disposition.sort')" prop="sort">
                  <a-input v-model="queryParam.sort" :placeholder="$t('user.disposition.inputSort')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- v-hasPermi="['user:disposition:add']" -->
        <a-button type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
        <!-- v-hasPermi="['user:disposition:edit']" -->
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit" />{{ $t('common.edit') }}
        </a-button>
        <!-- v-hasPermi="['user:disposition:remove']" -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:disposition:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >

         <span slot="isOpen" slot-scope="text, record">
          <a-switch :checkedChildren="$t('system.yes')" :unCheckedChildren="$t('system.no')" v-model="record.isOpen == 1" @change="changeIsOpen($event,record)"/>
        </span>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <!-- v-hasPermi="['user:disposition:edit']" -->
          <a-divider type="vertical" />
          <!-- v-hasPermi="['user:disposition:edit']" -->
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
          <!-- v-hasPermi="['user:disposition:remove']" -->
          <a-divider type="vertical" />
          <!-- v-hasPermi="['user:disposition:remove']" -->
          <a @click="handleDelete(record)">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDisposition,listDisposition, delDisposition } from '@/api/user/disposition'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Disposition',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        type: null,
        title: null,
        titleEn: null,
        titleCn: null,
        titleBm: null,
        titleIn: null,
        content: null,
        contentEn: null,
        contentCn: null,
        contentBm: null,
        contentIn: null,
        isOpen: null,
        sort: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  computed: {
    columns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('user.disposition.title'),
          dataIndex: 'titleIn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('system.titleEn'),
          dataIndex: 'titleEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('system.titleCn'),
          dataIndex: 'titleCn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('system.titleArabic'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('user.disposition.content'),
          dataIndex: 'contentIn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('user.disposition.content') + '(' + this.$t('system.titleEn') + ')',
          dataIndex: 'contentEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('user.disposition.content') + '(' + this.$t('system.titleCn') + ')',
          dataIndex: 'contentCn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('user.disposition.content') + '(' + this.$t('system.titleArabic') + ')',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('user.disposition.isOpen'),
          dataIndex: 'isOpen',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isOpen' },
        },
        {
          title: this.$t('system.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  watch: {
  },
  methods: {
    /** 查询配置列表 */
    getList () {
      this.loading = true
     pageDisposition(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        type: undefined,
        title: undefined,
        titleEn: undefined,
        titleCn: undefined,
        titleBm: undefined,
        titleIn: undefined,
        content: undefined,
        contentEn: undefined,
        contentCn: undefined,
        contentBm: undefined,
        contentIn: undefined,
        isOpen: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delDisposition(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('system.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk () {
          that.download('user/disposition/export', {
            ...that.queryParam
          }, `${that.$t('user.disposition.config')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
